import * as React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import { useForm, Controller } from "react-hook-form";
import { z } from "utils/zod-pt";
import { zodResolver } from "@hookform/resolvers/zod";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import { customTheme } from "styles/CustomField";
import CustomLabel from "components/Label";
import * as palette from "styles/variables";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { IconButton, InputAdornment } from '@mui/material';
import { CircularProgress } from "@mui/material";

const style = {
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: "5px",
  p: 4,
};

export default function ModalParams({ open, handleClose, onSubmit, isLoading}) {
  const paramsSchema = z.object({
    valueParam: z
      .string()
      .refine((val) => !isNaN(Number(val)) && Number(val) >= 0, {
        message: "Insira um valor numérico válido",
      }),
    justification: z
      .string()
      .min(1, "A descrição é obrigatória")
      .max(200, "A descrição deve ter no máximo 200 caracteres"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(paramsSchema),
    mode: "all",
    criteriaMode: "all",
  });

  const outerTheme = useTheme();
  return (
    <ThemeProvider theme={customTheme(outerTheme)}>
      <div>
        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            {/* Cabeçalho */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="h5"
                component="h2"
                style={{
                  marginLeft: "auto",
                  color: "#F26A1D",
                  fontFamily: "Poppins",
                }}
              >
                Edição de valor
              </Typography>
              <div
                onClick={handleClose}
                style={{ marginLeft: "auto", cursor: "pointer" }}
              >
                <CloseIcon />
              </div>
            </div>

            {/* Formulário */}
            <form
              style={{ marginTop: "20px", width: "100%", display: 'flex', flexDirection: 'column' }}
              onSubmit={handleSubmit(onSubmit)}
            >
              {/* <h3 style={{fontWeight: '400', marginBottom: '0'}} >VALOR:</h3> */}
              <CustomLabel textLabel="NOVO VALOR:" />

              {/* Campo Valor */}

              <Controller
                name="valueParam"
                control={control}
                render={({ field }) => (
                  <TextField
                    style={{ marginTop: "1%"}}
                    {...field}
                    hiddenLabel
                    //   label="Valor"
                    placeholder="Digite o novo valor"
                    type="number"
                    error={!!errors.valueParam}
                    helperText={errors.valueParam?.message}
                    // fullWidth
                    margin="normal"
                    variant="outlined"
                  />
                )}
              />
              {/* <h3 style={{fontWeight: '400', marginBottom: '0'}} >DESCRIÇÃO:</h3> */}
              <CustomLabel textLabel="DESCRIÇÃO:" />
              {/* Campo Descrição */}
              <Controller
                name="justification"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    style={{ marginTop: "1%" }}
                    multiline
                    placeholder="Justifique a alteração do valor  "
                    rows={3}
                    error={!!errors.justification}
                    helperText={errors.justification?.message}
                    fullWidth
                    margin="normal"
                    variant="outlined"
                  />
                )}
              />

              {/* Botão de submissão */}
              <Button
                type="submit"
                variant="contained"
                disabled={isLoading}
                startIcon={!isLoading && <CheckBoxOutlinedIcon/>}
                style={{ marginTop: "20px", alignSelf: "end", backgroundColor: palette.lightVerde }}
                InputProps={{
                  startAdornment: (
                    isLoading && (
                      <InputAdornment position="start">
                        <CircularProgress size={20} />
                      </InputAdornment>
                    )
                  ),
                }}
              >
                Salvar
              </Button>
            </form>
          </Box>
        </Modal>
      </div>
    </ThemeProvider>
  );
}
